// extracted by mini-css-extract-plugin
export var orderDetails = "_ks-2";
export var orderImage = "_ks-1";
export var orderMeta = "_ks-3";
export var orderSummary = "_ks-0";
export var rightArrow = "_ks-4";